<div class="flex gap-1">
  <p-button icon="true"
            severity="contrast"
            rounded="true"
            styleClass="!size-[1.75rem] !px-0 !py-0 !bg-transparent !text-(--p-primary-200) hover:!text-(--p-primary-500) focus:!text-(--p-primary-500) !border-0"
            [text]="true"
            (click)="service.maximize(popup().id)"
            [pTooltip]="'@@floating-popup-maximize' | translate"
            tooltipPosition="bottom"
            tooltipStyleClass="text-[0.75rem] !z-screen-overlay-1">
    <svg-icon src="icons/icon-expand-popup.svg" name="icon-expand-popup"></svg-icon>
  </p-button>

  <p-button icon="true"
            severity="contrast"
            rounded="true"
            styleClass="!size-[1.75rem] !px-0 !py-0 !bg-transparent !text-(--p-primary-200) hover:!text-(--p-primary-500) focus:!text-(--p-primary-500) !border-0"
            [text]="true"
            (click)="service.close(popup().id)"
            [pTooltip]="'@@shared-close' | translate"
            tooltipPosition="bottom"
            tooltipStyleClass="text-[0.75rem] !z-screen-overlay-1">
    <svg-icon src="icons/icon-close-popup.svg" name="icon-close-popup"></svg-icon>
  </p-button>
</div>